import builder from '../builder';
import CreditCard1 from '../../streamline-icons/bold/credit-card-1.svg';

export default builder('IconCreditCard1Bold', CreditCard1);
